import { runtimeEnv } from "config/runtimeEnv";

// Multi-tenancy Phase 4b — the boot question: "whose site is this browser
// looking at?" Answered by the public GET /admin-api/v1/tenant-config
// endpoint (registry face only: id/name/subdomain/branding/config — never
// tenant data). Tenant selection travels in x-tenant: on a subdomain the
// hostname answers; on a common URL the id learned from identify-first login
// is remembered here and sent explicitly.
//
// The last-seen config is cached in localStorage so repeat visits paint the
// right brand instantly; the fetch refreshes it in the background of boot.

const STORAGE_KEY = "tenantConfig";
const TENANT_ID_KEY = "tenantId";
const FETCH_TIMEOUT_MS = 3000;

let tenantConfig = null;

export const getTenantConfig = () => tenantConfig;
export const getBranding = () => (tenantConfig && tenantConfig.branding) || {};

export const rememberTenantId = (tenantId) => {
  if (tenantId) localStorage.setItem(TENANT_ID_KEY, tenantId);
};

export const loadTenantConfig = async () => {
  const cached = localStorage.getItem(STORAGE_KEY);
  if (cached) {
    try {
      tenantConfig = JSON.parse(cached);
    } catch (e) {
      localStorage.removeItem(STORAGE_KEY);
    }
  }

  try {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), FETCH_TIMEOUT_MS);
    const headers = {};
    const tenantId = localStorage.getItem(TENANT_ID_KEY);
    if (tenantId) headers["x-tenant"] = tenantId;

    const response = await fetch(
      `${runtimeEnv("API_BASE_URL")}/admin-api/v1/tenant-config`,
      { headers, signal: controller.signal }
    );
    clearTimeout(timer);

    if (response.ok) {
      const body = await response.json();
      if (body && body.data) {
        tenantConfig = body.data;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(body.data));
        rememberTenantId(body.data.id);
      }
    }
  } catch (e) {
    // Unreachable/slow backend: the cached copy (or built-in defaults) stand.
  }
  return tenantConfig;
};
